<template>
    <modal class="waiterSalesModel" :isShow="isShow" @keyup.esc="hide">
        <div class="header">
            <template v-if="title">{{title}}</template>
            <template v-else-if="waiSaleType==1">选择服务员</template>
            <template v-else>选择销售员</template>
        </div>
        <div class="modal-body">
            <div class="search-box">
                <div class="search"><input type="text" placeholder="请输入编码、姓名检索" v-model="searchText" @keyup.enter="search()"></div>
                <div class="search-bnt">搜索</div>
            </div>
            <div class="panel panel-table" >
                <div class="panel-heading">
                    <div class="tr">
                        <div class="td selectChecked">选择</div>
                        <div class="td code">编码</div>
                        <div class="td name">名称</div>
                    </div>
                </div>
                <div class="panel-body">
                    <div class="tr" v-for="item in posUsersPage" :key="item" :class="{selected:item.User_ID==seleUser?.User_ID}" @click="posUsersClick(item)"  @dblclick="doubleClick(item)" > 
                        <div class="td selectChecked">
                            <span class="iconfont " :class="item.User_ID==seleUser?.User_ID?'icon-iconoption1':'icon-iconoption'"></span>
                        </div>
                        <div class="td code">{{item.User_Code}}</div>
                        <div class="td name">
                            <span>{{item.User_Name}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="item-operation">
                &nbsp; &nbsp; {{pageIndex}}/{{pageCount}} 页 &nbsp; {{posUsersFilter?.length}}条
                <div class="float-right">
                    <page-turning class="bnt-fangxiang" v-model="pageIndex" :pageCount="pageCount" type="up"><i class="iconfont icon-fangxiang-up"></i></page-turning>
                    <page-turning class="bnt-fangxiang" v-model="pageIndex" :pageCount="pageCount"><i class="iconfont icon-fangxiang-down"></i></page-turning>
                    <!-- <div class="bnt-fangxiang" ref="order-up"><i class="iconfont icon-fangxiang-up"></i></div>
                    <div class="bnt-fangxiang" ref="order-down"><i class="iconfont icon-fangxiang-down"></i></div> -->
                </div>
            </div>
        </div>
        <div class="footer-box">
            <button class="btn btn-cancel" @click="hide()">取消</button>
            <button class="btn btn-confirm" @click="waiSaleConfirm()">确认</button>
        </div>
    </modal>
</template>

<script>

/**选择开卡人  */
export default {
    name:"waiterSalesModel",
    emits:["closeModel","waiSaleConfirm"],
    props:{ 
        isShow:Boolean,
        WaiterList:Object,
        SalesList:Object,
        waiSaleType:Number,
        //标题
        title:{
            type:String,
            default:""
        }
    },
    data(){
        return{
            /**操作人 */
            posUsers:null,
            //选中的人
            seleUser:null,
            /**搜索 */
            searchText:'',
            pageIndex:1,
            pageSize:10
        }
    },
    mounted(){
        this.$nextTick(()=>{
            this.init();
        });
    },
    computed:{
        /**筛选 */
        posUsersFilter(){
            let data=this.posUsers||[];
            let MenuTxt=this.searchText.toLowerCase();
            if(MenuTxt!=''){
                data=data?.filter(item=>(item.User_Code||"").toLowerCase().indexOf(MenuTxt)>=0 || (item.User_Name||"").toLowerCase().indexOf(MenuTxt)>=0)
            }
            return data;
        },
        /**分页数据 */
        posUsersPage(){
            return this.posUsersFilter.slice((this.pageIndex-1)*this.pageSize,this.pageIndex*this.pageSize);
        },
        /**总页数 */
        pageCount(){
            return Math.ceil(this.posUsersFilter.length/this.pageSize)||1;
        }
    },
    watch:{
        isShow(newValue){
            if(newValue){
                this.init();
            }
        },
        searchText(){
            this.seleUser=null;
            this.pageIndex=1;
        }
    },
    methods:{
        /**初始化数据 */
        init(){
            this.seleUser={}
            this.searchText=''
            if(this.waiSaleType==1){
                this.posUsers=this.WaiterList;
            }else{
                this.posUsers=this.SalesList;
            }
        },
        /**选择开卡人 */
        posUsersClick(item){
            this.seleUser = item
        },
        /**双击测试 */
        doubleClick(item){
             this.seleUser = item
            this.$emit("waiSaleConfirm",this.seleUser);
        },
        hide(){
            this.$emit("closeModel");
        },
        waiSaleConfirm(){
            this.$emit("waiSaleConfirm",this.seleUser);
        }
    }
}
</script>

<style lang="scss">
@import "./waiterSalesModel.scss";
</style>